<input #input hidden [id]="controlId" [value]="value" />
<div
  [attr.contenteditable]="disabled ? false : 'plaintext-only'"
  #content
  role="textbox"
  aria-multiline="true"
  [attr.aria-labelledby]="labelId"
  class="textarea-input"
  [class.empty]="!value"
  [attr.data-placeholder]="placeholder"
  (input)="handleInput($event)"
  (paste)="handlePaste($event)"
  (blur)="handleBlur()"
  [class.error]="error"
  [class.disabled]="disabled"></div>
<span class="char-count" *ngIf="maxLength && showCharCount">{{ input.value.length }}/{{ maxLength }}</span>
